import { useSelector } from "react-redux";
import { currentSelectedLanguage, FOCUS_LOSS_COMBINED_TYPE, splitFocusLossValue } from "../../../../StateManagement/actions";
import { useRef } from "react";
import { AppContext } from "../../../../AppContext";


const tabMap = {
  'Personal': 'personalTab',
  'Company': 'companyTab',
  'Admin': 'AdminTab'
};


const useGeneralControlData = () => {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const defaultSetting = useSelector((state) => state.settings.defaultSetting);
  const settings = useSelector((state) => state.settings);
  //const excludeControls = useSelector((state) => state.settings.excludeControls);
  const lookupData = useSelector((state) => state.settings.lookupData);
  const eDisclosureSecurityLevels = useRef([]);
  const tabKey = tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];

  let controls = [];

  let commonSettings = [];
  let configLevel = "";
  let getDefaultSetting = {};
  let contentSecuritySettingId = "";
  if (settings[tabKey]?.selectedTab === "DirectSendDefaults") {
    getDefaultSetting = settings[tabKey]?.settingsData.find(s => s.settingFor === defaultSetting) || {};
    configLevel = getDefaultSetting?.configLevel;
    commonSettings = getDefaultSetting?.commonSettings;
  }
  else if (settings[tabKey]?.selectedTab === "ContentSecurity") {
    configLevel = settings[tabKey]?.settingsData[0]?.configLevel;
    commonSettings = settings[tabKey]?.settingsData[0]?.commonContentSecuritySetting;
    contentSecuritySettingId = settings[tabKey]?.settingsData[0]?.id;
  }

  else {
    configLevel = settings[tabKey]?.settingsData[0]?.configLevel;
    commonSettings = settings[tabKey]?.settingsData;
  }
  const defaultDropdownValueByType = {
    FocusOffLimit: "1",
    WhenLimitisReached: "EndSession",
  };
  const createSettingControlObject = (id, type, label, controlType, options = [], showTooltip = false, tooltip = "", level = "common", isGroupedControl = false, extendClassName = "", placeholder = "", preSelect = false, isDisabled = false) => {
    let setting = {};
    let className = `mb-3 row align-items-center mx-1 ${settings.settingFor === "User" ? extendClassName : settings.defaultSetting === "RApp" && type !== "FocusLossLimit" ? "mt-comapny-11rm" : ""}
    ${type === "FocusLossLimit" ? "focusOffLimit-row" : ""} ${isDisabled && settings[tabKey]?.selectedTab === "ContentSecurity" ? "disabledContentSecurityGroup" : ""}`;
    let isProfileTab = false;
    if (settings[tabKey]?.selectedTab === "Profile") {
      setting.keyValue = commonSettings[type];
      setting.lockSetting = "true";
      isProfileTab = true;
    } else {
      if (type === "DefaultSettingsFor") {
        setting = {
          keyValue: defaultSetting === "Gateway" ? "0" : "1",
          isLock: "false",
          isOverride: "false",
        }
      } else {
        const settingLookupType = type === "FocusLossLimit" ? FOCUS_LOSS_COMBINED_TYPE : type;
        setting = commonSettings?.find(s => s.type?.trim() === settingLookupType?.trim()) || {};

      }
    }
    if (type === "DateFormat" && setting.keyValue) {
      const colonIndex = setting.keyValue.indexOf(":");
      if (colonIndex !== -1) {
        const dateFormat = setting.keyValue
          .substr(colonIndex + 1)
          .trim();
        localStorage.setItem("DateFormatValueOriginal", dateFormat.toUpperCase());
      }
    }

    if (type === "EDisclosure" && setting?.keyCollection?.length > 0) {
      eDisclosureSecurityLevels.current = setting.keyCollection?.map((item, index) => {
        return {
          id: index,
          label: (item.level === "L1" ? selectedLanguage.LstLanguageCodes.UI_TrackViews : item.level === "L2" ? selectedLanguage.LstLanguageCodes.UI_TrackReaders : selectedLanguage.LstLanguageCodes.UI_LimitReaders),
          level: item.level,
          levelFlag: item.levelFlag ? "true" : "false",
          ...item
        }
      }) || [];
    }

    let ipChangeSecurityLevels = [];
    // Responsible for configuring UI state for IPChangeDetection sub-options (Ban Reader, ReAuthenticate Reader, Notify Sender)
    if (type === "IPChangeDetection") {
      const ipChangeSetting = commonSettings?.find((c) => c.type === "IPChangeDetection");
      const isIPChangeDisabled = !ipChangeSetting || ipChangeSetting.keyValue === "false";
      const opts = ipChangeSetting?.ipChangeDetectionOptions || ipChangeSetting?.IPChangeDetectionOptions || {};

      // Determine checked states from dedicated ipChangeDetectionOptions object
      const isBanReaderSelected = opts.banReader === true || opts.BanReader === true;
      const isReAuthenticateReaderSelected = opts.reAuthenticateReader === true || opts.ReAuthenticateReader === true;
      const isNotifySenderSelected = opts.notifySender === true || opts.NotifySender === true;

      const ipLevelsConfig = [
        {
          level: "BanReader",
          label: selectedLanguage.LstLanguageCodes.UI_BanReader || "Ban Reader",
          isChecked: isBanReaderSelected,
        },
        {
          level: "ReAuthenticateReader",
          label: selectedLanguage.LstLanguageCodes.UI_ReAuthenticateReader || "ReAuthenticate Reader",
          isChecked: isReAuthenticateReaderSelected,
        },
        {
          level: "NotifySender",
          label: selectedLanguage.LstLanguageCodes.UI_NotifySender || "Notify Sender",
          isChecked: isNotifySenderSelected,
        },
      ];

      // Responsible for applying mutual exclusivity between BanReader and ReAuthenticateReader,
      // and graying out all sub-options when main IPChangeDetection setting is disabled.
      ipChangeSecurityLevels = ipLevelsConfig.map((item, index) => {
        let isItemDisabled = isIPChangeDisabled;
        if (!isIPChangeDisabled) {
          if (item.level === "BanReader") {
            // BanReader is disabled if ReAuthenticateReader is selected
            isItemDisabled = isReAuthenticateReaderSelected;
          } else if (item.level === "ReAuthenticateReader") {
            // ReAuthenticateReader is disabled if BanReader is selected
            isItemDisabled = isBanReaderSelected;
          } else {
            // NotifySender is independent
            isItemDisabled = false;
          }
        }
        return {
          id: index,
          label: item.label,
          level: item.level,
          levelFlag: item.isChecked,
          disabled: isItemDisabled,
        };
      });
    }

    const isDirectSendDefaultTab = settings[tabKey]?.selectedTab === "DirectSendDefaults";
    const isContentSecurityTab = settings[tabKey]?.selectedTab === "ContentSecurity";
    const isAdminDocumentTab = settings[tabKey]?.selectedTab === "Document";
    let isOverride = isDirectSendDefaultTab || isContentSecurityTab
      ? (isContentSecurityTab && isDisabled ? 'false' : setting.isOverride)
      : ((isAdminDocumentTab && type !== "maxViewsPerDocument") || (type === "MaxPagesPerRPD" || type === "ImageResolution")) ? 'false' : setting.overrideUserSetting;
    // let isLock = isDirectSendDefaultTab || isContentSecurityTab ? setting.isLock : ((isAdminDocumentTab && type === "DirectSendDefaults")|| (!isAdminDocumentTab && (type === "MaxPagesPerRPD"|| type === "ImageResolution"))) ? 'false' : setting.lockSetting;

    let isLock = isDirectSendDefaultTab || isContentSecurityTab
      ? (isContentSecurityTab && isDisabled ? 'false' : setting.isLock)
      : ((isAdminDocumentTab && (type === "DirectSendDefaults" || type === "DateControlFormat" || type === "ExcelSupport")) || (!isAdminDocumentTab && (type === "MaxPagesPerRPD" || type === "ImageResolution")))
        ? 'false'
        : setting.lockSetting;
    const settingId = isDirectSendDefaultTab ? getDefaultSetting?.id : isContentSecurityTab ? contentSecuritySettingId : setting.id;
    const showLockIconOnDisable = isDirectSendDefaultTab || isContentSecurityTab ? (setting.isLock === 'true' && !(isContentSecurityTab && isDisabled)) : setting.lockSetting === 'true';
    // if(type === "maxViewsPerDocument"  && !isAdminDocumentTab){
    //   if(setting.prevLock === "true"){
    //     isLock = "true";
    //   }
    // }

    let value = "";
    if (type === "LandingPage" && setting.keyValue?.includes('_')) {
      value = setting.keyValue?.split('_')[0];
    } else {
      value = setting.keyValue;
    }
    if (type === "FocusLossLimit") {
      value = splitFocusLossValue(setting.keyValue).enabled;
    }
    if (type === "FocusOffLimit") {
      if (controlType === "Checkbox") {
        value = setting.keyValue?.Enabled === true ? "true" : "false";
      } else if (controlType === "Dropdown") {
        value = setting.keyValue?.Limit;
      }
    }
    if (controlType === "Dropdown" && options?.length > 0 && value) {
      const normalize = (str) => (str || "").toString().trim().toLowerCase().replace(/\s+/g, "");
      const normalizedValue = normalize(value);
      const matchedOption = options.find((o) => normalize(o.key) === normalizedValue || normalize(o.keyValue) === normalizedValue);
      if (matchedOption) {
        value = matchedOption.key;
      }
    }
    let dropdownFallbackValue = "";
    if (controlType === "Dropdown" && options?.length > 0) {
      const knownDefaultKey = defaultDropdownValueByType[type];
      const normalize = (str) => (str || "").toString().trim().toLowerCase().replace(/\s+/g, "");
      const normalizedDefaultKey = normalize(knownDefaultKey);
      const matchedDefault = knownDefaultKey ? options.find((o) => normalize(o.key) === normalizedDefaultKey || normalize(o.keyValue) === normalizedDefaultKey) : null;
      dropdownFallbackValue = matchedDefault?.key ?? options[0]?.key ?? "";
    }

    if (isDisabled && controlType === "Checkbox") {
      value = "false";
    } else if (isDisabled && controlType === "Dropdown") {
      value = dropdownFallbackValue;
    } else if (controlType === "Dropdown" && options?.length > 0) {
      const normalize = (str) => (str || "").toString().trim().toLowerCase().replace(/\s+/g, "");
      const normalizedValue = normalize(value);
      const isKnownOption = options.some((o) => normalize(o.key) === normalizedValue || normalize(o.keyValue) === normalizedValue);
      if (!isKnownOption) {
        value = dropdownFallbackValue;
      }
    }
    const ALWAYS_SHOW_HISTORY_TYPES = [
      "FocusProtection",
      "ResumeOnFullScreen",
      "FocusLossLimit",
      "WhenLimitisReached",
      "BanReader",
      "NotifySender",
    ];
    let showHistory = true;
    if (ALWAYS_SHOW_HISTORY_TYPES.includes(type)) {
      showHistory = true;
    } else if (
      (type === "EDisclosure" && isGroupedControl && eDisclosureSecurityLevels.current.length > 0) ||
      (type === "IPChangeDetection" && isGroupedControl) ||
      type === "LandingPage_ManageItem" ||
      (type === "FocusOffLimit" && isGroupedControl)
    ) {
      showHistory = false;
    }

    if (options?.length > 0 && (type === "ServiceLanguage" || type === "AppLanguage")) {
      const matchedOption = options.find(option => option.key?.toLowerCase() === value?.toLowerCase());
      if (matchedOption) {
        value = matchedOption.key;
      }
    }

    if (type === "MaxReadsperReader" || type === "maxViewsPerDocument") {
      value = value === "0" ? "" : value;
    }

    let disableSharevotes = false;
    if (type === "ShareVotes") {
      disableSharevotes = commonSettings.find((c) => c.type === "Voting" && c.keyValue === "false") ? true : false;
      isOverride = disableSharevotes ? "false" : isOverride;
      isLock = disableSharevotes ? "false" : isLock;
    }
    const focusLossLimitKey = type === "FocusLossLimit" ? splitFocusLossValue(setting.keyValue).limit : "";
    const focusLossLimitValue = type === "FocusLossLimit"
      ? (options?.find((option) => option.key === focusLossLimitKey || option.keyValue === focusLossLimitKey)?.key || options?.[0]?.key || "") : "";
    return {
      id,
      controlType,
      label: selectedLanguage.LstLanguageCodes[label],
      containerClassname: className,
      isShowToolTip: showTooltip,
      tooltip: isDisabled ? "" : tooltip,
      options,
      focusLossLimitValue,
      isShowLockIconOnDisable: showLockIconOnDisable,//isLock === "false" ? false : true,
      value: (value && value !== "") ? value : dropdownFallbackValue,
      settingType: type,
      settingId: settingId,
      level,
      Override: isOverride || "",
      Lock: isLock || "",
      configLevel: (isDirectSendDefaultTab || isContentSecurityTab ? configLevel : setting?.configLevel),
      placeholder,
      preSelect,
      isGroupedControl,
      showHistory,
      disabled: isDisabled,
      ...(type === "ShareVotes" && {
        disableSharevotes: disableSharevotes,
      }),
      ...(isGroupedControl && type === "IPChangeDetection" && {
        groupedSecurityLevels: ipChangeSecurityLevels,
      }),
      ...(isGroupedControl && type === "EDisclosure" && {
        disableTermsOfService: (commonSettings.find((c) => c.type === "EDisclosure" && c.keyValue === "false")) ? true : false,
        eDisclosureSecurityLevels: eDisclosureSecurityLevels.current.map(item => ({
          ...item,
          disabled: commonSettings.find(c => c.type === "EDisclosure" && c.keyValue === "false") ? true : false
        })),
        groupedSecurityLevels: eDisclosureSecurityLevels.current.map(item => ({
          ...item,
          disabled: commonSettings.find(c => c.type === "EDisclosure" && c.keyValue === "false") ? true : false
        }))
      }),
      ...(isProfileTab && { isProfileTab }),
      ...(isAdminDocumentTab && type !== "maxViewsPerDocument" && {
        disableOverrideForAdminDocument: true
      }),
      ...(isAdminDocumentTab && (type === "DirectSendDefaults" || type === "ContentSecurity" || type === "DateControlFormat" || type === "ExcelSupport") && {
        disableLockForAdminDocument: true
      }),
      ...(type === "MaxPagesPerRPD" || type === "ImageResolution") && !isAdminDocumentTab && setting.prevLock === "true" && {
        disableAdminLockedControls: true
      },
      ...((type === "MaxPagesPerRPD" || type === "ImageResolution") && (settings.settingFor === 'Company' && configLevel !== "User") && {
        disableOverrideLockControls: true
      }),
      ...(type === "RPDLite" && settings.settingFor === 'Company' && {
        disableOverrideLockControls: true
      }),
      ...((type === "SecureSend" || type === "MandatoryDescription") && {
        hideOverrideLockControls: true
      }),
      ...(isContentSecurityTab && isDisabled && {
        disableOverrideLockControls: true,
        [`disable${type}`]: true,
      }),
    };
  };

  if (settings[tabKey]?.selectedTab === "Profile") {
    controls = [
      createSettingControlObject("0", "firstName", "UI_FirstName", "Textbox", [], false, "", "common", false, "mt-5r"),
      createSettingControlObject("1", "lastName", "UI_LastName", "Textbox"),
      createSettingControlObject("2", "email", "UI_Email", "Textbox"),
      createSettingControlObject("3", "companyName", "UI_CompanyName", "Textbox"),
    ];
  } else if (settings[tabKey]?.selectedTab === "General") {
    controls = [
      createSettingControlObject("0", "DateFormat", "UI_DateFormat", "Dropdown", lookupData?.dateFormatOptions, false, "", "common", false, "mt-10rm"),
      ...(AppContext.IsEnableTimeZone === true ? [createSettingControlObject("1", "TimeZone", "UI_TimeZone", "Dropdown", lookupData?.TimeZoneOptions)] : []),
      createSettingControlObject("2", "ServiceLanguage", "UI_ServiceLanguage", "Dropdown", lookupData?.serviceLanguageOptions, true, selectedLanguage.LstLanguageCodes.UI_ServiceLanguageInfo),
      createSettingControlObject("3", "AppLanguage", "UI_AppLanguage", "Dropdown", lookupData?.appLanguageOptions),
      createSettingControlObject("4", "LandingPage", "UI_LandingPage", "Dropdown", lookupData?.landingPageOptions?.landingOptions),
    ];
    const setting = commonSettings.find(s => s.type?.trim() === "LandingPage") || {};
    if (setting && setting.keyValue?.includes("Manage")) {
      controls.push(createSettingControlObject("4", "LandingPage_ManageItem", "", "Dropdown", lookupData?.landingPageOptions?.manageOptions, false, "", "common", true));
    }
  } else if (settings[tabKey]?.selectedTab === "DefaultDocumentSettings") {
    controls = [
      createSettingControlObject("0", "AccessControl", "UI_AccessControl", "Dropdown", lookupData?.accessControlOptions, false, "", "common", false, "mt-10rm"),
      createSettingControlObject("1", "BannedRegions", "UI_BannedRegions", "custom-Dropdown", lookupData?.bannedRegionOptions),
      createSettingControlObject("2", "AllowedIP", "UI_AllowedIP", "custom-Textbox"),
      createSettingControlObject("3", "Launches", "UI_Launches", "Dropdown", lookupData?.launchesOptions, true, selectedLanguage.LstLanguageCodes.UI_LaunchesInfo,),
      createSettingControlObject("4", "Expires", "UI_Expires", "Textbox", [], true, selectedLanguage.LstLanguageCodes.UI_ExpiresInfo, "common", false, "", selectedLanguage.LstLanguageCodes.UI_Expirydays),
      createSettingControlObject("5", "RestrictToDomains", "UI_RestrictToDomains", "Textbox", [], false, "", "common", false, "", selectedLanguage.LstLanguageCodes.UI_ExampleORGExample),
      createSettingControlObject("6", "Watermark", "UI_Watermark", "Dropdown", lookupData?.watermarkOptions),
      ...(settings.settingFor === 'Company' && configLevel !== "User" ? [createSettingControlObject("7", "MaxPagesPerRPD", "UI_MaxpagesperRPD", "Dropdown", lookupData?.maxPagesPerRPDOptions)] : []),
      createSettingControlObject("8", "maxViewsPerDocument", "UI_MaxviewsPerDocument", "Textbox", [], false, "", 'common', false, "", selectedLanguage.LstLanguageCodes.UI_Unlimited),
      ...(settings.settingFor === 'Company' && configLevel !== "User" ? [createSettingControlObject("9", "ImageResolution", "UI_Documentresolution", "Dropdown", lookupData?.imageResolutionOptions)] : []),
      createSettingControlObject("10", "MaxReadsperReader", "UI_MaxReadsperReader", "Textbox", [], false, "", 'common', false, "", selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("11", "SideNote", "UI_SideNote", "Text Area"),
      createSettingControlObject("12", "AllowResponseTo", "UI_AllowResponsesTo", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("13", "SendVerificationCode", "UI_SendVerificationCode", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("14", "ProofOfSending", "UI_ProofOfSending", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("15", "DisplayDistributionList", "UI_DisplayDistributionlist", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("16", "Voting", "UI_Voting", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("17", "ShareVotes", "UI_ShareVotes", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("18", "NotificationOfReading", "UI_NotificationofReading", "Checkbox", [], false, "", "common", false, "", "", true),
      ...(!AppContext.ContentSecurity ? [createSettingControlObject("19", "Identifyleakers", "UI_IdentifyLeakers", "Checkbox", [], false, "", "common", false, "", "", true)] : []),
      createSettingControlObject("20", "TimeStamp", "UI_TimeStamp", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("21", "CanPrint", "UI_CanPrint", "Checkbox", [], false, "", "common", false, "", "", true),
      createSettingControlObject("24", "MaxPrintsPerReader", "UI_MaxPrintsPerReader", "Textbox", [], false, "", 'common', false, "", selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("25", "MaxPrintsPerDocument", "UI_MaxPrintsPerDocument", "Textbox", [], false, "", 'common', false, "", selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("22", "PageLevelRestrictions", "UI_Pagelevelrestrictions", "Radio"),
      createSettingControlObject("23", "SMSAuthentication", "UI_SMSAuthentication", "Radio"),

    ];
  } else if (settings[tabKey]?.selectedTab === "DirectSendDefaults") {
    controls = [
      createSettingControlObject("0", "DefaultSettingsFor", "UI_DefaultSettingsFor", 'Dropdown', lookupData?.defaultSettingsForOptions, false, "", "common", false, "mt-10rm"),
    ]
    if (defaultSetting === "Gateway") {
      controls.push(createSettingControlObject("1", "Gateway", "UI_Gateway", "Dropdown", lookupData?.gatewayOptions, true, selectedLanguage.LstLanguageCodes.UI_GatewayInfo));
      controls.push(createSettingControlObject("2", "GatewayAccessControl", "UI_AccessControl", "Dropdown", lookupData?.accessControlOptions, false, selectedLanguage.LstLanguageCodes.UI_GatewayAccessControlInfo));
    }
  } else if (settings[tabKey]?.selectedTab === "Advance") {
    controls = [
      createSettingControlObject("0", "PasscodeExpiryPolicy", "UI_PasscodeExpiryPolicy", "Dropdown", lookupData?.passcodeExpiryPolicyOptions, false, "", "common", false, "mt-10rm"),
      createSettingControlObject("1", "PasscodeLength", "UI_PasscodeLength", "Dropdown", lookupData?.PasscodeLengthOptions, false, "", "common", false, ""),
      createSettingControlObject("2", "TrackKilledDocument", "UI_TrackKilledDocuments", "Radio", [], false, "", "common"),
      ...(settings.settingFor === 'Company' && configLevel !== "User" ? [createSettingControlObject("3", "MandatoryDescription", "UI_MandatoryDescription", "Radio", [], false, "", "common")] : []),
      ...(settings.settingFor === 'Company' && configLevel !== "User" ? [createSettingControlObject("4", "SecureSend", "UI_SecureSend", "Radio", [], false, "", "common")] : []),
      createSettingControlObject("5", "IPChangeDetection", "UI_IPChangeDetection", "Radio"),
      createSettingControlObject("6", "IPChangeDetection", "", "Checkbox", [], false, "", "common", true),
      createSettingControlObject("7", "EDisclosure", "UI_EDisclosure", "Radio"),
      createSettingControlObject("8", "EDisclosure", "", "Checkbox", [], false, "", "common", true),
      createSettingControlObject("9", "TermsOfService", "UI_TermsOfService", "RichTextEditor", [], false, "", "common", true)
    ]
  } else if (settings[tabKey]?.selectedTab === "Document") {
    controls = [
      createSettingControlObject("0", "MaxPagesPerRPD", "UI_MaxpagesperRPD", "Dropdown", lookupData?.maxPagesPerRPDOptions),
      createSettingControlObject("1", "maxViewsPerDocument", "UI_MaxviewsPerDocument", "Textbox", [], false, "", 'common', false, "", selectedLanguage.LstLanguageCodes.UI_Unlimited),
      createSettingControlObject("2", "ImageResolution", "UI_Documentresolution", "Dropdown", lookupData?.imageResolutionOptions),
      createSettingControlObject("3", "DirectSendDefaults", "UI_DirectSendDefaults", "Radio"),
      createSettingControlObject("4", "ContentSecurity", "UI_ContentSecurity", "Radio"),
      createSettingControlObject("5", "DateControlFormat", "UI_TimeControl", "Radio"),
      ...(AppContext.IsEnableExcelSupport ? [createSettingControlObject("6", "ExcelSupport", "UI_ExcelSupport", "Radio")] : []),];
  } else if (settings[tabKey]?.selectedTab === "ContentSecurity") {
    const isEnabled = (type) => (commonSettings?.find((s) => s.type?.trim() === type) || {}).keyValue === "true";
    const isRShieldEnabled = isEnabled("RShield");
    const isFocusProtectionEnabled = isEnabled("FocusProtection");
    const isFocusOffLimitEnabled = splitFocusLossValue((commonSettings?.find((s) => s.type?.trim() === FOCUS_LOSS_COMBINED_TYPE) || {}).keyValue).enabled === "true";
    const disabledIfNoRShield = !isRShieldEnabled;
    const disabledIfNoFocusProtection = !isRShieldEnabled || !isFocusProtectionEnabled;
    const disabledIfNoFocusOffLimit = disabledIfNoFocusProtection || !isFocusOffLimitEnabled;
    const whenLimitReachedTooltip = (<> <strong> {selectedLanguage.LstLanguageCodes.UI_EndSession}: </strong>{" "}  {selectedLanguage.LstLanguageCodes.UI_EndSessionInfo}{" "}
      <strong> {selectedLanguage.LstLanguageCodes.UI_Reauthenticate}: </strong>{" "} {selectedLanguage.LstLanguageCodes.UI_ReauthenticateInfo} </>); const whenLimitReachedFallbackOptions = [
        { key: "EndSession", keyValue: selectedLanguage.LstLanguageCodes.UI_EndSession },
        { key: "Reauthenticate", keyValue: selectedLanguage.LstLanguageCodes.UI_Reauthenticate },
      ];
    const whenLimitReachedOptions = (lookupData?.WhenLimitisReachedOptions?.length > 0
      ? lookupData?.WhenLimitisReachedOptions : whenLimitReachedFallbackOptions);
    controls = [
      createSettingControlObject("0", "RShield", "UI_RShield", "Radio", [], false, "", "commonContentSecuritySetting", false, "mt-10rm"),
      createSettingControlObject("1", "FocusProtection", "UI_FocusProtection", "Checkbox", [], true, selectedLanguage.LstLanguageCodes.UI_FocusProtectionInfo, "commonContentSecuritySetting", false, "", "", true, disabledIfNoRShield),
      createSettingControlObject("2", "ResumeOnFullScreen", "UI_ViewOnlyinFullScreen", "Checkbox", [], true, selectedLanguage.LstLanguageCodes.UI_ViewOnlyinFullScreenInfo, "commonContentSecuritySetting", false, "", "", true, disabledIfNoFocusProtection),
      createSettingControlObject("3", "FocusLossLimit", "UI_FocusoffLimit", "Checkbox", lookupData?.FocusOffLimitOptions, true, selectedLanguage.LstLanguageCodes.UI_FocusLossLimitInfo, "commonContentSecuritySetting", false, "focusOffLimit-row", "", true, disabledIfNoFocusProtection),
      createSettingControlObject("4", "WhenLimitisReached", "UI_WhenLimitisReached", "Dropdown", whenLimitReachedOptions, true, whenLimitReachedTooltip, "commonContentSecuritySetting", false, "", "", false, disabledIfNoFocusOffLimit),
      createSettingControlObject("5", "BanReader", "UI_BanReader", "Checkbox", [], true, selectedLanguage.LstLanguageCodes.UI_BanReaderInfo, "commonContentSecuritySetting", false, "", "", true, disabledIfNoRShield),
      createSettingControlObject("6", "NotifySender", "UI_NotifySender", "Checkbox", [], true, selectedLanguage.LstLanguageCodes.UI_NotifySenderInfo, "commonContentSecuritySetting", false, "", "", true, disabledIfNoRShield),
      createSettingControlObject("7", "IDLeakers", "UI_IDLeakers", "Radio", [], false, "", "commonContentSecuritySetting", false, " "),
      createSettingControlObject("9", "IDLeakersType", "UI_IDLeakersType", "Dropdown", lookupData?.IDLeakersTypeOptions, false, "", "commonContentSecuritySetting", false, ""),
    ];
  }
  else if (settings[tabKey]?.selectedTab === "Storage") {
    controls = [
      createSettingControlObject("0", "RPDLite", "UI_RPDLite", "Radio", [], false, "", "common", false, "mt-10rm")
    ]
  }
  return controls;
};

export default useGeneralControlData;